import { render } from "./Tenancies.vue?vue&type=template&id=59bf0b36&ts=true"
import script from "./Tenancies.vue?vue&type=script&lang=ts"
export * from "./Tenancies.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__